import { ComponenteProvider, ListagemComponentesResponse } from "src/providers/estoque/ComponenteProvider"
import { ListagemItem } from "../../types"
import { ID_BATERIA, ID_BATERIA_HIBRIDA, ID_INVERSOR_ONDA_SENOIDAL } from "src/components/componentes/types"

interface BuscarAcessoriosPorGrupoRequest {
  regioesId: number[]
  segmento?: string
}

const componenteProvider = new ComponenteProvider()

const getOrdemCategoria = (categoriaId: number) => {
  if (categoriaId === ID_BATERIA_HIBRIDA) return 1;
  return 0;
};

export const buscarAcessoriosPorGrupo = async ({ regioesId, segmento = "on" }: BuscarAcessoriosPorGrupoRequest) => {
  const resultCategorias = await componenteProvider.buscarCategoriasPorGrupo("acessorios") || [];
  const acessoriosId = resultCategorias.map(item => item.id) || [];
  const categorias = [...acessoriosId, ID_BATERIA_HIBRIDA];
  if (categorias.length) {
    const resutlComponentes = await componenteProvider.buscarComponentesPorCategoria({
      categoria_componentes_id: categorias,
      regiao_id: regioesId,
      segmento
    }) || [];

    const items = resutlComponentes?.sort(
      (a: ListagemComponentesResponse, b: ListagemComponentesResponse) =>
        getOrdemCategoria(Number(a.categoria_componentes_id)) -
        getOrdemCategoria(Number(b.categoria_componentes_id))
    );

    const newAcessorios = items.map((item: ListagemComponentesResponse): ListagemItem => {
      return {
        componente_id: Number(item.id),
        nome: item.nome || '',
        descricao: item.descricao || '',
        quantidade: 0,
        altura: Number(item.altura || 0),
        categoria_componentes_id: Number(item.categoria_componentes_id || 0),
        largura: Number(item.largura || 0),
        peso: Number(item.peso || 0),
        potencia: 0,
        valor: 0,
        valor_unitario: 0,
        exibir_popup_parceiro: item.exibir_popup_parceiro || false,
      }
    })

    return newAcessorios
  }

  return []
}